import Button from '../ui/Button.jsx';
import { Card, CardBody, CardFooter } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';
import { Col, Row } from '../ui/Layout.jsx';

const ResultContribution = ({ ...props }) => {
    const { heading, text, items, button, fn } = props;
    const { formData } = props;

    return (
        <div className="component-result-contribution">
            <HeadingOne heading={heading} />

            <Card>
                <CardBody>
                    <div className="text-xl" dangerouslySetInnerHTML={{ __html: text }}></div>

                    <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-5">
                        {items.map((item, index) => {
                            if (item.score_max >= formData.score_positive && formData.score_positive >= item.score_min) {
                                return (
                                    <div key={index} className="contribution --active">
                                        <div className="contribution-title">{formData.data.title.label}</div>
                                        <img className="contribution-image" src={formData.data.image.path} />
                                        <div className="contribution-text">{formData.data.text.text}</div>

                                        <Row justify="between">
                                            <Col base="auto">
                                                <div className="contribution-likes">{item.likes} likes</div>
                                            </Col>
                                            <Col base="auto">
                                                <div className="contribution-views">{item.views} views</div>
                                            </Col>
                                        </Row>
                                    </div>
                                );
                            } else
                                return (
                                    <div key={index} className="contribution">
                                        <div className="contribution-title">{item.title}</div>
                                        <img className="contribution-image" src={item.image} />
                                        <div className="contribution-text">{item.text}</div>

                                        <Row justify="between">
                                            <Col base="auto">
                                                <div className="contribution-likes">{item.likes} likes</div>
                                            </Col>
                                            <Col base="auto">
                                                <div className="contribution-views">{item.views} views</div>
                                            </Col>
                                        </Row>
                                    </div>
                                );
                        })}
                    </div>
                    {items.map((item, index) => {
                        if (item.score_max >= formData.score_positive && formData.score_positive >= item.score_min) {
                            return <div className="contribution-result">{item.result}</div>;
                        }
                    })}
                </CardBody>
                <CardFooter>
                    <Button type={button.type} onClick={() => fn.handleAction(button.action)}>
                        {button.title}
                    </Button>
                </CardFooter>
            </Card>
        </div>
    );
};

export default ResultContribution;
